import { MeasureRowError } from "@/components/portal/apps/reporting/datasources/MeasureRowError";

/**
 * A connection field's ODBC metacharacter message (`@/lib/odbcConnectionFields`),
 * under the field: `AlertCircle` plus the text, `role="alert"` (ui-standards §3
 * rule 1, the same markup as a measure row's problem). Renders nothing when
 * the value is clean. The input carries `odbcInputProps(id, message)`.
 */
export function OdbcFieldError({
  id,
  message,
}: {
  id: string;
  message: string | null | undefined;
}) {
  if (!message) return null;
  return (
    <MeasureRowError id={id} message={message} testId="odbc-field-error" />
  );
}
